import { useState, useEffect } from 'react';

import CopyButton from '../widgets/CopyButton';
import * as utils from '../../services/utils';

function ClientCredCmd(props) {
  const authorizeParam = utils.AUTH_INFO;

  const [authorizeData, setAuthorizeData] = useState({});
  const [authURL, setAuthURL] = useState('');

  const cmdData = props.cmdData;
  cmdData.displayCmdData = (data) => {
    setAuthorizeData(data);
  };
  
  useEffect(() => {
    buildRequestData();
  }, [authorizeData]);

  function buildRequestData() {
    const reqData = cmdData.buildAuthCmdData();
    // console.log(reqData);

    let reqDataStr = reqData.reqURL
    .concat('\n').concat(authorizeParam.httpMethod).concat(': ').concat(reqData.reqMethod);

    reqDataStr = reqData.reqHeaders ? reqDataStr
      .concat('\n').concat(authorizeParam.httpHeaders).concat(': ')
      .concat('\n').concat(utils.objectToString(reqData.reqHeaders)) : reqDataStr;

    reqDataStr = reqData.reqParams ? reqDataStr
      .concat('\n').concat(authorizeParam.httpBody).concat(': ')
      .concat('\n').concat(utils.objectToString(reqData.reqParams)) : reqDataStr;

    // console.log(reqDataStr);
    setAuthURL(reqDataStr);
  }

  function DisplayHeaders() {    
    const headers = authorizeData.reqHeaders;
    return headers ? Object.keys(headers).map((key) => {
      return <div key={key}>
        <span className="aqua-text">{key}:</span> <span className="light-blue-text">{headers[key]}</span>
      </div>
    }) : <div></div>
  }

  // Access Token
  const tokenData = 
  <div>
    <div id="generatedCmd" className="main-form-output white-text">
      <span className="code-line light-blue-text">{authorizeData.tokenUri}</span>

      <span className="code-line code-line-param"> {authorizeParam.httpMethod}: <span></span>
        <span className="light-blue-text">{authorizeData.reqMethod}</span></span> 

      <span className="code-line code-line-param"> {authorizeParam.httpHeaders}:</span>
        <span className="code-line code-line-param"><DisplayHeaders></DisplayHeaders></span>

      <span className="code-line code-line-param"> {authorizeParam.httpBody}:</span>
      <span className="code-line code-line-param aqua-text">  {authorizeParam.grantType}: <span></span>
        <span className="light-blue-text">{utils.CLIENT_CRED_GRANT_TYPE}</span></span>
     {authorizeData.scopes && <span className="code-line code-line-param aqua-text"> {authorizeParam.scopes}: <span></span>
        <span className="light-blue-text">{authorizeData.scopes}</span></span>}
    </div>

    <CopyButton data={authURL}></CopyButton>

  </div>

  if (authorizeData.tokenUri) {  
    return (    
      <div className="card card-body code-block">
        {tokenData}    
       </div>
    );
  }

  return <div></div>
}

export default ClientCredCmd;
